import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	EditEmployeeTransactionsContainer,
	EditItemsContainer,
} from "./style";
import { NewsItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useNewsContext } from "../../context/NewsContext/NewsContext";

const AddNews = () => {
	const { addNews, loadingAddNewsData } = useNewsContext();
	return (
		<EditEmployeeTransactionsContainer>
			<EditItemsContainer>
				<h3>Yeni Haber Ekleme</h3>
				<Divider />
				<Collapse
					items={NewsItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={CollapseExpandIcon}
					defaultActiveKey={["1", "2", "3"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={addNews} loading={loadingAddNewsData}>
						Haber Ekle
					</MainButtonComponent>
				</ActionButtonComponent>
			</EditItemsContainer>
		</EditEmployeeTransactionsContainer>
	);
};

export default AddNews;
